import { render, staticRenderFns } from "./VkAutocompleteInput.vue?vue&type=template&id=0870a40b&"
import script from "./VkAutocompleteInput.vue?vue&type=script&lang=ts&"
export * from "./VkAutocompleteInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports